<template>
  <div class="pagination">
    <span class="previous">
      <a @click="prevPageFn" v-if="prevPage > 0">
        <svg id="ico-left" viewBox="0 0 24.063 48"> <path d="M21.35.494a1.525 1.525 0 0 1 2.248 0 1.783 1.783 0 0 1 0 2.4L3.836 23.999l19.762 21.1a1.78 1.78 0 0 1 0 2.4 1.52 1.52 0 0 1-2.248 0L.464 25.199a1.784 1.784 0 0 1 0-2.4z"></path> </svg>
        <span>Poprzednia</span>
      </a>
    </span>
    <span class="count" v-if="count > 0">Strona {{current}} z {{count}}</span>
    <span class="next">
      <a @click="nextPageFn" v-if="nextPage <= count">
        <span>Następna</span>
        <svg id="ico-right" viewBox="0 0 24.063 48"> <path d="M2.713 47.505a1.525 1.525 0 0 1-2.248 0 1.783 1.783 0 0 1 0-2.4L20.227 24 .465 2.9a1.78 1.78 0 0 1 0-2.4 1.52 1.52 0 0 1 2.248 0l20.886 22.3a1.784 1.784 0 0 1 0 2.4z"></path> </svg>
      </a>
    </span>
  </div>
</template>

<script>
import getUrlParameter from '@/shared/geturlparamter'
export default {
  name: 'SearchPagination',
  props: {
    querySearch: undefined,
    pagesCount: undefined,
    pageCurrent: undefined,
    typePagination: undefined
  },
  data: function () {
    return {
      current: 0,
      count: this.pagesCount,
      nextPage: 0,
      prevPage: 0,
      filterProp: undefined
    }
  },
  created: function () {
    let pageUrl = Number(getUrlParameter('p'))
    if (getUrlParameter('p') !== '' && pageUrl !== 1 && pageUrl !== 0) {
      this.current = pageUrl - 1
    }
    if (pageUrl === 1 || pageUrl === 0 || pageUrl === '') {
      this.current = 1
    } else {
      this.current = pageUrl
    }
    this.pageStatus()
  },
  methods: {
    pageStatus () {
      // eslint-disable-next-line

      this.nextPage = Number(getUrlParameter('p') || 1) + 1
      this.prevPage = Number(getUrlParameter('p') || 1) - 1
    },
    nextPageFn () {
      this.current = this.current + 1
      this.$emit('nextPageGo', this.current)
      this.pageStatus()
    },
    prevPageFn () {
      this.current = this.current - 1
      this.$emit('prevPageGo', this.current)
      this.pageStatus()
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  width: 100%;
}
.pagination {
    margin-top: 20px;
    margin-bottom: 30px;
    text-align: center;
    font-size: 0;
    @media (max-width: 767px) {
      margin-top: 20px;
    }

    > * {
        display: inline-block;
        vertical-align: top;
    }

    // page-numbers
    .numbers {
        margin: 0 10px;

        @media (max-width: 767px) {
            display: none;
        }
    }

    .page-numbers {
        display: inline-block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #e3e6db;
        text-align: center;
        font-size: 13px;
        color: #010101;
        transition: all 0.15s ease;

        &:not(:first-child) {
            margin-left: -1px;
        }

        &.current {
            background-color: #e3e6db;
        }

        &:not(.current):not(.dots):hover {
            color: #8ab82d;
        }
    }

    // previous
    .previous {
        margin: 0 3px;

        a {
            display: inline-block;
            padding: 0 24px;
            min-width: 40px;
            height: 40px;
            line-height: 40px;
            border: 1px solid #e3e6db;
            text-align: center;
            text-transform: uppercase;
            font-size: 13px;
            color: #010101;
            border-radius: 50px;
            transition: background 200ms ease-in-out, color 200ms ease-in-out;
            svg {
                display: inline-block;
                width: 7px;
                height: 12px;
                transform: translateY(1px) translateZ(0);
            }

            @media (max-width: 767px) {
              padding: 0;
              text-align: center;
              width: 40px;
              border-radius: 50%;
              text-indent: -1px;
            }
            @media (min-width: 768px) {
              &:hover {
                color: #fff;
                background: #6ED2B5;
                border-color: #6ED2B5;
              }
            }

            span {
                margin-left: 5px;
                @media (max-width: 767px) {
                  display: none;
                }
            }

            @media (max-width: 340px) {
                padding: 0 10px;

                span {
                    margin-left: 10px;
                }
            }
        }
    }

    // next
    .next {
        margin: 0 3px;

        a {
            display: inline-block;
            padding: 0 32px;
            min-width: 40px;
            height: 40px;
            line-height: 40px;
            background-color: #8ab82d;
            text-align: center;
            text-transform: uppercase;
            font-size: 13px;
            color: #fff;
            border-radius: 50px;
            transition: background 200ms ease-in-out, color 200ms ease-in-out;
            @media (max-width: 767px) {
              padding: 0 25px;
              text-align: center;
              border-radius: 30px;
            }
            @media (min-width: 768px) {
              &:hover {
                color: #fff;
                background: #6ED2B5;
              }
            }

            span {
                margin-right: 5px;
            }

            svg {
              display: inline-block;
              width: 7px;
              height: 12px;
              transform: translateY(1px) translateZ(0);
            }

            @media (max-width: 340px) {
                padding: 0 10px;

                span {
                    margin-right: 10px;
                }
            }
        }
    }
    .count {
      font-size: 12px;
      margin: 11px 15px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Algolia/components/search-pagination.vue